import React from 'react';
import { ConfigProvider } from 'antd';
import viVN from 'antd/locale/vi_VN';
import AppRoutes from './routes';
const App: React.FC = () => {
  return (
    <ConfigProvider locale={viVN}>
      <div className='App'>
        <AppRoutes />
      </div>
    </ConfigProvider>
  );
};

export default App;
